import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition } from './../../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Web\AiProducts\StartAiCustomerRegistrationController::__invoke
* @see Http/Controllers/Web/AiProducts/StartAiCustomerRegistrationController.php:22
* @route '/ai-products/register/start'
*/
const StartAiCustomerRegistrationController = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: StartAiCustomerRegistrationController.url(options),
    method: 'post',
})

StartAiCustomerRegistrationController.definition = {
    methods: ["post"],
    url: '/ai-products/register/start',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Web\AiProducts\StartAiCustomerRegistrationController::__invoke
* @see Http/Controllers/Web/AiProducts/StartAiCustomerRegistrationController.php:22
* @route '/ai-products/register/start'
*/
StartAiCustomerRegistrationController.url = (options?: RouteQueryOptions) => {
    return StartAiCustomerRegistrationController.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Web\AiProducts\StartAiCustomerRegistrationController::__invoke
* @see Http/Controllers/Web/AiProducts/StartAiCustomerRegistrationController.php:22
* @route '/ai-products/register/start'
*/
StartAiCustomerRegistrationController.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: StartAiCustomerRegistrationController.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Web\AiProducts\StartAiCustomerRegistrationController::__invoke
* @see Http/Controllers/Web/AiProducts/StartAiCustomerRegistrationController.php:22
* @route '/ai-products/register/start'
*/
const StartAiCustomerRegistrationControllerForm = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: StartAiCustomerRegistrationController.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Web\AiProducts\StartAiCustomerRegistrationController::__invoke
* @see Http/Controllers/Web/AiProducts/StartAiCustomerRegistrationController.php:22
* @route '/ai-products/register/start'
*/
StartAiCustomerRegistrationControllerForm.post = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: StartAiCustomerRegistrationController.url(options),
    method: 'post',
})

StartAiCustomerRegistrationController.form = StartAiCustomerRegistrationControllerForm

export default StartAiCustomerRegistrationController